import { render, staticRenderFns } from "./NonConformityProfileForm.vue?vue&type=template&id=2b646f42&scoped=true&"
import script from "./NonConformityProfileForm.vue?vue&type=script&lang=js&"
export * from "./NonConformityProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b646f42",
  null
  
)

export default component.exports